import { render, staticRenderFns } from "./CtrlCamposPage.vue?vue&type=template&id=19a15d1a&scoped=true"
import script from "./CtrlCamposPage.vue?vue&type=script&lang=js"
export * from "./CtrlCamposPage.vue?vue&type=script&lang=js"
import style0 from "./CtrlCamposPage.vue?vue&type=style&index=0&id=19a15d1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a15d1a",
  null
  
)

export default component.exports